<a class="skip-link" href="#main-content">Skip to content</a>

<div class="case-strip">
  <div class="page-shell case-strip__inner">
    <span style="font-weight:bold">Flo Period Tracker App Settlement</span>
    <span style="font-size: .9em"><i>Frasco, et al. v. Flo Health Inc., et al.,</i> No. 3:21-cv-00757 (N.D. Cal.)</span>
    <!--<span>United States District Court, Northern District of California</span>-->
  </div>
</div>

<header class="site-header">
  <div class="page-shell site-header__inner">
    <a class="brand" [routerLink]="['/home']" aria-label="Settlement home">
      <img class="brand__logo" src="../../../assets/images/ab-data-logo.png" alt="ab DATA">
    </a>

    <nav class="site-nav" aria-label="Primary navigation">
      <a [routerLink]="['/home']">Home</a>
      <a [routerLink]="['/court-documents']">Court Documents</a>
      <a [routerLink]="['/file-not-noticed']">File a Claim</a>
      <a [routerLink]="['/key-contacts']">Key Contacts</a>
      <a [routerLink]="['/contact']">Contact Information</a>
      <a href="tel:+18667789626">1-866-778-9626</a>
    </nav>
  </div>
</header>
